/**
 * Types and constants for scheduling settings
 */

import i18n from '../../i18n/config';

// System defaults
export const SYSTEM_DEFAULTS = {
  workdayStartHour: 8,
  workdayStartMinute: 0,
  workdayEndHour: 16,
  workdayEndMinute: 0,
  skipWeekends: true,
  skipHolidays: true,
  holidayCountryCode: 'NO',
} as const;

// Country options for holiday calendars
export const getCountryOptions = () => [
  { code: 'NO', name: i18n.t('scheduling.countries.NO') },
  { code: 'SE', name: i18n.t('scheduling.countries.SE') },
  { code: 'DK', name: i18n.t('scheduling.countries.DK') },
  { code: 'FI', name: i18n.t('scheduling.countries.FI') },
  { code: 'IS', name: i18n.t('scheduling.countries.IS') },
  { code: 'GB', name: i18n.t('scheduling.countries.GB') },
  { code: 'DE', name: i18n.t('scheduling.countries.DE') },
  { code: 'FR', name: i18n.t('scheduling.countries.FR') },
  { code: 'ES', name: i18n.t('scheduling.countries.ES') },
  { code: 'IT', name: i18n.t('scheduling.countries.IT') },
  { code: 'NL', name: i18n.t('scheduling.countries.NL') },
  { code: 'BE', name: i18n.t('scheduling.countries.BE') },
  { code: 'PL', name: i18n.t('scheduling.countries.PL') },
  { code: 'US', name: i18n.t('scheduling.countries.US') },
];

// Base scheduling settings interface
export interface BaseSchedulingSettings {
  workdayStartHour: number;
  workdayStartMinute: number;
  workdayEndHour: number;
  workdayEndMinute: number;
  skipWeekends: boolean;
  skipHolidays: boolean;
  holidayCountryCode: string;
}

// Effective settings (resolved from system/org/team)
export interface EffectiveSchedulingSettings extends BaseSchedulingSettings {
  source: 'system' | 'organization' | 'team';
}

// Organization scheduling settings (all fields required)
export interface OrganizationSchedulingSettings extends BaseSchedulingSettings {
  id: number;
  organizationId: number;
  createdAt: string;
  updatedAt: string;
}

// Organization input (for updates - all fields required)
export interface OrganizationSchedulingSettingsInput {
  workdayStartHour: number;
  workdayStartMinute: number;
  workdayEndHour: number;
  workdayEndMinute: number;
  skipWeekends: boolean;
  skipHolidays: boolean;
  holidayCountryCode: string;
}

// Team scheduling settings (fields are nullable - can override org settings)
export interface TeamSchedulingSettings {
  id: number;
  teamId: number;
  workdayStartHour: number | null;
  workdayStartMinute: number | null;
  workdayEndHour: number | null;
  workdayEndMinute: number | null;
  skipWeekends: boolean | null;
  skipHolidays: boolean | null;
  holidayCountryCode: string | null;
  createdAt: string;
  updatedAt: string;
}

// Team input (for updates - all fields optional/nullable)
export interface TeamSchedulingSettingsInput {
  workdayStartHour?: number | null;
  workdayStartMinute?: number | null;
  workdayEndHour?: number | null;
  workdayEndMinute?: number | null;
  skipWeekends?: boolean | null;
  skipHolidays?: boolean | null;
  holidayCountryCode?: string | null;
}
